class Archive {
    constructor() {

    }

    init(helpers) {
        const self = this;

        self.helpers = helpers;

        if (!document.body.classList.contains('archive') && !document.body.classList.contains('blog')) return;

        const filterGroups = document.querySelectorAll('.filtering-content:not(.filtering-content--desktop) .filter-groups > .group'),
            desktopFilterGroups = document.querySelectorAll('.filtering-content--desktop .filter-groups > .group');

        filterGroups.forEach((group) => {
             const form = document.querySelector('.filtering-content:not(.filtering-content--desktop) form'),
                checkedInputs = form.querySelectorAll('.filter-groups input[type="checkbox"]:checked');
             

            group.addEventListener('change', function(e) {
                self.updateState(e, form, checkedInputs, self);
            });
        });

        desktopFilterGroups.forEach((group) => {
            const form = document.querySelector('.filtering-content--desktop.form'),
                checkedInputs = form.querySelectorAll('.filter-groups input[type="checkbox"]:checked');

            group.addEventListener('change', function(e) {
                self.updateState(e, form, checkedInputs, self);
            });
        });
    }

    updateState(e, form, checkedInputs, self) {
        if (e.target.tagName !== 'INPUT') return;

        if (e.target.getAttribute('type' !== 'checkbox')) return;

        e.stopImmediatePropagation();

        let currentCheckedInputs = form.querySelectorAll('.filter-groups input[type="checkbox"]:checked'),
            submitButton = form.querySelector('.footer > .submit > .button'),
            submitButtonText = submitButton.querySelector('.text'),
            count = e.currentTarget.querySelectorAll('input[type="checkbox"]:checked').length,
            visualCounter = e.currentTarget.querySelector('.counter--visual-only'),
            state = e.currentTarget.querySelector('button > .text > .state'),
            counter = state.querySelector('.counter'),
            descriptor = state.querySelector('.descriptor');

        if (!self.helpers.areNodeListsEqual(checkedInputs, currentCheckedInputs)) {
            console.log('Node lists are not equal');
            submitButton.classList.add('update');
            submitButtonText.replaceChild(document.createTextNode(i18n['archive']['filters']['submit']['update']), submitButtonText.childNodes[0]);
        } else {
            console.log('Node lists are equal');
            submitButton.classList.remove('update');
            submitButtonText.replaceChild(document.createTextNode(i18n['archive']['filters']['submit']['default']), submitButtonText.childNodes[0]);
        }
        
        visualCounter.dataset.count = count;
        counter.replaceChild(document.createTextNode(count), counter.childNodes[0]);

        switch (count) {
            case 0:
                descriptor.replaceChild(document.createTextNode(i18n['archive']['filters']['selected']['plural']), descriptor.childNodes[0]);
                state.hidden = true;

                break;
            case 1:
                descriptor.replaceChild(document.createTextNode(i18n['archive']['filters']['selected']['singular']), descriptor.childNodes[0]);
                state.hidden = false;

                break;
            default:
                descriptor.replaceChild(document.createTextNode(i18n['archive']['filters']['selected']['plural']), descriptor.childNodes[0]);
                state.hidden = false;
        }

        if (form.closest('.filtering-content--desktop')) return;

        let totalCount = currentCheckedInputs.length,
            triggerButton = document.querySelector('.filtering .filters > .trigger-button'),
            totalVisualCounter = triggerButton.querySelector('.counter--visual-only'),
            totalState = triggerButton.querySelector('.state'),
            totalCounter = totalState.querySelector('.counter'),
            totalDescriptor = totalState.querySelector('.descriptor');

        totalVisualCounter.dataset.count = totalCount;
        totalCounter.replaceChild(document.createTextNode(totalCount), totalCounter.childNodes[0]);

        switch (totalCount) {
            case 0:
                totalDescriptor.replaceChild(document.createTextNode(i18n['archive']['filters']['selected']['plural']), totalDescriptor.childNodes[0]);
                state.hidden = true;

                break;
            case 1:
                totalDescriptor.replaceChild(document.createTextNode(i18n['archive']['filters']['selected']['singular']), totalDescriptor.childNodes[0]);
                state.hidden = false;

                break;
            default:
                totalDescriptor.replaceChild(document.createTextNode(i18n['archive']['filters']['selected']['plural']), totalDescriptor.childNodes[0]);
                state.hidden = false;
        }
    }
}

export default Archive;